import { IRootState } from "app/model"
import { getStore } from "app/store/store"
import { MAX_PHONE_WIDTH_IN_PX, MAX_TABLET_WIDTH_IN_PX } from "ui/model"

export function isDesktopScreen(): boolean {
  return document.body.offsetWidth > MAX_TABLET_WIDTH_IN_PX
}

export const isPhoneScreen = (state?: IRootState): boolean => {
  if (!state) {
    state = getStore().getState()
  }
  return state.ui.container.width < MAX_PHONE_WIDTH_IN_PX
}

export const isTabletScreen = (state?: IRootState): boolean => {
  if (!state) {
    state = getStore().getState()
  }
  return state.ui.container.width < MAX_TABLET_WIDTH_IN_PX
}
